<template>
    <div class="mybet-container" v-if="!isLoading">
        <Title :title="getTranslatedText('my bets')" />

        <div class="mybet-nav">
            <p class="mybet-nav__item" :class="{ 'active': navSelected.id == nav.id }" v-for="(nav, index) in navItem"
                :key="index" @click="selectNavOption(nav)">
                {{ getTranslatedText(nav.title) }}
            </p>
        </div>

        <UnsettledComponent v-if="navSelected.id == 1" :bets="bets" :paginator="paginator"
            :currencySymbol="currencySymbol" />
        <SettledComponent v-else :bets="bets" :paginator="paginator" :currencySymbol="currencySymbol" />
        <div class="mybet-action">
            <ButtonCommon text="Back Home" class="button__custom-1" @action="backToHome" />
        </div>
    </div>
    <Loading v-else />
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import UnsettledComponent from "@/components/my-bets/unsettled.vue";
import SettledComponent from "@/components/my-bets/settled.vue";
import Title from "@/components/common/title/index.vue";
import ButtonCommon from "@/components/common/button";
import Loading from '@/components/common/loading/loading.vue'
import mybetService from "@/services/my-bets/index.service.ts"
import HomeService from "@/services/home/index.service.ts";
import EventBus from '@/utils/EventBus';
import { notifyApiError } from "@/utils/notify";
import { getStateStore } from "@/utils/utils.ts"

export default {
    mixins: [languageMixins],
    components: { Loading, ButtonCommon, Title, UnsettledComponent, SettledComponent },
    data() {
        return {
            isLoading: false,
            navItem: [
                {
                    id: 1,
                    title: "unsettled",
                },
                {
                    id: 2,
                    title: "settled",
                }
            ],
            navSelected: {},
            bets: [],
            paginator: {},
            currentPage: 1,
            currencySymbol: '',
        }
    },
    async created() {
        let setting = getStateStore().accountSetting;
        this.currencySymbol = setting.currency_symbol;
        this.navSelected = this.navItem[0]
        await this.ensureGameMarket();
        this.handleInitMybetData()

        EventBus.on('change-page', (page) => this.handleChangePage(page))
    },
    methods: {
        async ensureGameMarket() {
            if ((this.$store.state.gameMarket || []).length > 0) {
                return;
            }
            try {
                const res = await HomeService.getGameMarket();
                if (res?.status === "success" && Array.isArray(res.result)) {
                    this.$store.commit("SET_GAME_MARKET", res.result);
                }
            } catch {
                // Numbers still render without ball colours if this fails.
            }
        },

        async handleInitMybetData() {
            this.isLoading = true
            try {
                let payLoad = {
                    page: this.currentPage,
                    limit: 5,
                    status: this.navSelected.title
                }
                let res = await mybetService.getMybets(payLoad);
                if (res.status == 'success') {
                    this.bets = res.result;
                    this.paginator = res.paginator;
                }
                this.isLoading = false;
            } catch (error) {
                notifyApiError(error);
                this.isLoading = false;
            }
        },
        selectNavOption(nav) {
            this.currentPage = 1;
            this.navSelected = nav;
            this.handleInitMybetData();
        },
        handleChangePage(page) {
            this.currentPage = page;
            this.handleInitMybetData();
        },
        backToHome() {
            const query = this.$route.query;
            this.$router.push({ path: "/", query });
        }
    }
}
</script>
<style lang="scss">
@import "@/public/scss/my-bets/index.scss";
</style>